import styled from "styled-components";

export const IssueListBox = styled.ul`
  margin: 0 auto;
  max-width: 500px;
  margin-top: 48px;
`;
